export default "__VITE_PUBLIC_ASSET__2fa25b3d__"